let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
import React from "ES/lib/react";

let radio = require('ES/lib/radio');
let esUtils = require('ES/utils/esUtils');
let FormMixin = require('ES/widgets/forms/FormMixin');
let FormUtils = require('../../../utils/FormUtils');
let ErrorAlert = require('ES/widgets/ErrorAlert');
let SlideOpenDown = require('../../widgets/SlideOpenDown');
let HorizontalFields = require('ES/widgets/HorizontalFields');
var ServicesUtils = require('ES/utils/ServicesUtils');

let QuestionnaireForm = dd.createClass({
    mixins: [FormMixin],
    getInitialValuesSourceVersion: function (props) {
        return props;
    },
    getInitialValues: function (props) {
        return _.get(props, "initvals", {});
    },
    buildFields: function () {
        let speaker = _.get(this, "props.speaker", null);
        let key;

        let fields = {};

        _.each(_.get(speaker, "todolists", []), function (list) {
            key = "clientportal_qsntr_actionlist_id_" + list.id; //magic value; must match key in ClientportalController->questionnaireAction()
            fields[key] = {
                label: list.listname,
                type: "text",
                placeholder: "https://goo.gl/forms/PMK0lzlS6Z8DRE152",
                validate: FormUtils.v.optional,
            };
        });

        return fields;
    },
    __discardChanges: esUtils.wrapPreventDefault(function () {
        this._form_reset();
    }),

    render: function () {
        let fields = this.buildFields();
        let errors = this.state.errors || {};
        let changes_made = this._form_areChangesMade();
        let error_msg = _.get(this.props, "error_msg");
        let success_msg = _.get(this.props, "success_msg");

        return <form className='form-horizontal' onSubmit={this._form_onSubmit}>
            <h3>Pre-event Questionnaire</h3>
            <p>
                Enter the URL to the Google Form for your pre-event questionnaire. You can assign a specific Form to events using specific Action Lists. The STANDARD form will be used if there is not a specific one assigned to an event.
            </p>
            <p>
                <a href="https://espeakers.com/wiki/Pre-event_Questionnaire_in_the_Client_Portal" target="_blank">
                    Learn more about pre-event questionnaires <i style={{marginLeft: "0.5em", fontSize: "1.0em"}} className="fa fa-external-link"/>
                </a>
            </p>
            {HorizontalFields({
                fields: fields,
                errors: errors,
                buildInput: this._form_buildInput
            })}
            {SlideOpenDown({open: changes_made},
                HorizontalFields.FormButtons({onDiscard: this.__discardChanges})
            )
            }
            {success_msg && !changes_made &&
            <div className="alert alert-success">
                Saved.
            </div>}
            {ErrorAlert({
                message: error_msg
            })}

        </form>;
    }
});

module.exports = dd.createClass({
    mixins: [ServicesUtils.RadioAjaxMixin("save_ClientPortal_questionnaire")],

    getInitialState: function () {
        return {
            sid: -1,
            data: {},
            is_saving: false,
            error_msg: null,
            success_msg: null
        };
    },
    componentWillReceiveProps(props) {
        _.set(props, "config.questionnaire.sid", _.get(props, "config.sid"));
        this.setState({sid: props.config.sid, config: props.config, data: props.config.questionnaire, success_msg: null, error_msg: null});
    },
    //dd.form calls this._form_onSubmit, which in turn calls this because it was passed into QuestionnaireForm() as a parameter
    __onSubmit: function (data) {
        let self = this;
        radio('save_ClientPortal_questionnaire').broadcast(data.sid, data,
            function (sid, data) {
                if (_.get(self, "state.data.sid") == sid) {
                    self.setState({
                        sid: sid,
                        config: data,
                        data: _.get(data, "questionnaire"),
                        is_saving: false,
                        error_msg: null,
                        success_msg: "Saved."
                    });
                }
            },
            function (sid, message) {
                self.setState({error_msg: message, success_msg: null});
            });
    },
    __selectTextInput: function (e) {
        e.target.setSelectionRange(0, e.target.value.length);
    },
    render: function () {
        let {speaker, Displaylists} = this.props;

        return dd.div({},
            QuestionnaireForm({
                speaker,
                Displaylists,
                config: _.get(this, "state.config"),
                initvals: this.state.data,
                onSubmit: this.__onSubmit,
                error_msg: _.get(this.state, "error_msg"),
                success_msg: _.get(this.state, "success_msg")
            })
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/ClientPortal/QuestionnaireForm.js